<template>
  <tg-dialog
    ref="dialog"
    :theme="currentTheme"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="!noPrivilege"
    :showCancelBtn="!noPrivilege"
    @on-confirm="confirmHandler"
    width="20%"
  >
    <template slot="subject">{{ subject }}</template>

    <template slot="subtitle">
      <template v-if="noPrivilege">
        {{ $t("component.dialog.privilege.unauthorize") }}
      </template>
      <template v-else>({{ actionLabel }}) {{ privilegeLabel }}</template>
    </template>

    <el-alert
      v-show="
        item.privilege == 3 &&
        item.status == 1 &&
        role == 'member' &&
        !noPrivilege
      "
      type="tg-alert"
      :closable="false"
      center
      show-icon
    >
      <template slot="title">
        <span v-html="$t('component.dialog.privilege.note')"></span>
      </template>
    </el-alert>
  </tg-dialog>
</template>

<script>
import apis from "@/apis";
import TgDialog from "@/components/dialog/TgDialog";
const api = apis.tg_business;

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  props: {
    note: String,
    username: String,
    item: {
      type: Object,
      required: true,
    },
    role: String,
    noPrivilege: Boolean,
  },
  computed: {
    currentTheme() {
      if (this.noPrivilege) {
        return "noPrivilege";
      }
      return this.item && this.item.status === 1 ? "warning" : "info";
    },
    themeCls() {
      return {
        info: this.currentTheme === "info",
        warning: this.currentTheme === "warning",
      };
    },
    classes() {
      return ["tg-modal", this.themeCls];
    },
    iconClass() {
      return ["tg-modal-icon", this.themeCls];
    },
    subject() {
      return this.$t("component.dialog.subject.privilege", {
        username: this.username,
      });
    },
    actionLabel() {
      return this.$t(
        "component.dialog.status.privilege[" + this.item.status + "]"
      );
    },
    privilegeLabel() {
      return this.item.label;
    },
    request() {
      return {
        targetName: this.username,
        privilegeItem: this.item.privilege,
        privilegeType: this.item.type,
        privilegeStatus: this.item.status == 1 ? 0 : 1,
      };
    },
  },
  methods: {
    confirmHandler() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api[this.role].privilege
        .changePrivilege(this.request)
        .then((response) => {
          this.$emit("on-changed", response);
          if (this.$refs.dialog) {
            this.$refs.dialog.close();
          }
          loading.close();
        });
    },
  },
};
</script>
